import { apiMi4uVideoCall } from "../api";

export async function createParticipants(payload) {
  const {
    hash,
    customer_service_id,
    user_id,
    user_name,
    client_id,
    client_name,
  } = payload;

  try {
    const [user, client] = await Promise.all([
      apiMi4uVideoCall.post("/panel/participant", {
        hash,
        customer_service_id,
        user_id,
        client_id: 0,
        name: user_name,
      }),
      apiMi4uVideoCall.post("/panel/participant", {
        hash,
        customer_service_id,
        user_id: 0,
        client_id,
        name: client_name,
      }),
    ]);

    return {
      user: user.data,
      client: client.data,
    };
  } catch (error) {
    console.error("Error creating participants:", error);
    throw error;
  }
}

export async function createParticipant(data) {
  return apiMi4uVideoCall.post("/panel/participant", data);
}

export async function crateRoom() {
  return apiMi4uVideoCall.post("/panel/room").then((res) => res.data.hash);
}

export async function deleteRoom(hashRoom) {
  try {
    const { status } = await apiMi4uVideoCall.put("/panel/room/close", {
      hash: hashRoom,
      deleteMeeting: true,
    });
    return status;
  } catch (error) {
    return 400;
  }
}
